var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.664 21.334h-5.333A8.667 8.667 0 001.664 30v42.667a8.667 8.667 0 008.667 8.666h65.333a8.667 8.667 0 008.667-8.666V30a8.667 8.667 0 00-8.667-8.666h-5",
    stroke: "#393939",
    strokeWidth: 3.333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.336 15.666h30.333M28.336 27.334h30.333M28.336 38.666h18.667",
    stroke: "#393939",
    strokeWidth: 3.333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71 45.333V10.667A8.667 8.667 0 0062.333 2H23.667A8.667 8.667 0 0015 10.667v34.666",
    stroke: "#393939",
    strokeWidth: 3.333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 36l37.111 24.248a8.667 8.667 0 009.455.017L85 36M57 53.334l26.333 26.333M29.336 53.334L3.003 79.666",
    stroke: "#393939",
    strokeWidth: 3.333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurty);
export default __webpack_public_path__ + "static/media/securty.eb8dfae98b8e1ac5450de4416db95184.svg";
export { ForwardRef as ReactComponent };